import { apiUser } from "../Api/ApiInstance";

export async function SaveCreditApplication(values) {
  return await apiUser.post("api/nexus-main/creditApplication", values);
}

export async function CreditApplications() {
  return await apiUser.get("api/nexus-main/creditApplication");
}
